import React, { Component } from "react";
import { Paper } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';

class F113FormTable extends Component {
  render() {
    const { data = [], columns = [], showFilter = false } = this.props;
    
    const muiColumns = columns.map(col => ({
      field: col.name,
      headerName: col.title || col.name,
      width: col.width || 150,
      flex: !col.width ? 1 : undefined,
      renderCell: (params) => {
        const value = params.row[col.name];
        // If the value is a React element, render it directly
        if (React.isValidElement(value)) {
          return value;
        }
        // Otherwise use getCellValue if provided, or just return the value
        return col.getCellValue ? col.getCellValue(params.row, col.name) : value;
      },
      sortable: col.sortingEnabled !== false,
      filterable: col.filteringEnabled !== false,
      ...col
    }));

    const muiRows = data.map((row, index) => ({
      id: row.id !== undefined ? row.id : index,
      ...row
    }));

    return (
      <Paper style={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={muiRows}
          columns={muiColumns}
          pageSizeOptions={[5, 10, 15, 20]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10, page: 0 },
            },
          }}
          disableRowSelectionOnClick
          filterMode={showFilter ? 'client' : undefined}
        />
      </Paper>
    );
  }
}

export default F113FormTable;
